export const LOGIN_STREAK_STATUS = 'LOGIN_STREAK_STATUS'
export const LOGIN_STREAK_CLAIM = 'LOGIN_STREAK_CLAIM'
export const LOGIN_STREAK_REVIVE = 'loginStreakRevive'
export const LOGIN_STREAK_RESET = 'LOGIN_STREAK_RESET'
